import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LicenseService } from '../../../services/license.service';
import { FullscreenService } from '../../../services/fullscreen.service';
import { NotificationService } from '../../../services/notification.service';
import { Observable, BehaviorSubject } from 'rxjs';

import { ScormApiService } from './scorm.api.service';
import { AuthService } from '../../../services/auth.service';
import { LoadingPage } from '../../../../shared/components/loading/loading.page.component';

declare var $: any;
declare var API_1484_11: any;
declare var API: any;


const IMG_BUCKET_URL: string = 'http://itpx-cdn.s3.amazonaws.com/solar/scorm-player/';

@Component({
    selector: 'itpx-scorm',
    templateUrl: './scorm.component.html',
    styleUrls: ['./scorm.component.css']
})
export class ScormComponent extends LoadingPage implements OnInit, OnDestroy {

    private player: any;
    private scormLogoutTriggered = new BehaviorSubject<boolean>(false);
    private deliverableId: any;
    private measureScorm: any;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private licenseService: LicenseService,
        private authService: AuthService,
        private scormApiService: ScormApiService,
        private notificationService: NotificationService,
        private fullscreenService: FullscreenService
    ) {
        super();
        this.player = window;
    }

    private setScormTotalPages(totalPages: any){
      if(totalPages != null)
      try {
        let trackingData = this.scormApiService.getTrackingData();
        if (trackingData != null && (!trackingData.hasOwnProperty('totalPages') || trackingData.totalPages == null)) {
          trackingData.totalPages = totalPages;
          this.scormApiService.setTrackingData(this.deliverableId, trackingData);
        }
      }catch (e) {
        console.log('Error setting total pages in scorm tracking data')
      }
    }

    ngOnInit() {

        this.initScormButtons();

        this.measureScorm = new Observable((observer) => {
            try {
              console.log('Trying to get total pages')
              let totalPages = $('#contentIFrame').contents().find('html').find('frameset').children().contents().children().find('.slidercontroller').text().split('/')[1].trim();
              if(this.deliverableId) {
                this.licenseService.setTrackingTotalPages({assignmentId: this.deliverableId, totalPages: totalPages})
                  .neverError()
                  .subscribe(_ => {
                    this.setScormTotalPages(totalPages);
                  });
              }
              observer.next(totalPages);
              observer.complete();
            }catch(e){
              observer.error('Error loading total pages from scorm');
            }
        });

        // Hide useless(?) scorm buttons because they break style
        $(document).arrive('#navigationContainer', function () {
            $('#navigationContainer').remove();
        });

        $('#drawerExample2').hide();

        // Show or hide table of contents depending on number of items
        $(document).arrive('#treeContainer', () => {
            let anchors = $('#treeContainer a');

            if (anchors.length <= 1) {
                $('#drawerExample2').remove();
            } else {
                $('#drawerExample2').show();
                let self = this;
                $('#treeContainer a').click(function () {
                    self.loading();
                    $(this).prop('href', window.location.href);
                    $('.drawer').drawer('hide');
                    setTimeout(() => {
                        self.ready();
                    }, 5000);
                    return true;
                });
            }
        });

        // Navigate to dummy page which will redirect back
        // We do this to trigger scorm content refresh to fit resolution
        this.fullscreenService.onFullscreen()
            .skip(1)
            .subscribe(_ => this.router.navigate(['app/dummy']));

        let routeData = this.route.params
            .take(1)
            .map(params => ({ assignmentId: params['assignmentId'], deliverableId: params['deliverableId'] }))
            .cacheResult();

        // Navigate to course page only if the scorm exit was triggered by
        // user clicking 'exit' button
        this.scormApiService.onScormExit()
            .filter(saved => this.router.url.indexOf('/app/scorm') > -1 && !this.scormLogoutTriggered.getValue())
            .withLatestFrom(routeData, (_, routeParams) => routeParams)
            .bindToLifecycle(this)
            .subscribe(data => this.router.navigate(['/app/course', data.assignmentId]));

        routeData
          .subscribe(data => this.deliverableId = data.deliverableId);

        // Initially start the scorm player
        routeData
            .flatMap(data => Observable.zip(
                this.licenseService.getScormTracking(data.deliverableId).map(body => body.data),
                this.licenseService.getScormManifest(data.deliverableId).map(body => body.data),
                (trackingData, manifest) => ({ trackingData: trackingData, manifest: manifest, routeData: data })
            ))
            .flatMap(data => this.startScormPlayer(data.routeData.deliverableId, data.manifest, data.trackingData))
            .bindToLifecycle(this)
            .subscribe(
                params => {
                  this.ready();
                  this.measureScorm
                      .retryWhen(errors => errors.delay(3000).take(10).concat(Observable.throw('Error')))
                      .subscribe();
                },
                err => this.handleError(err)
            );
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    private startScormPlayer(deliverableId: string, manifest: string, trackingData: any): Observable<boolean> {
        return Observable.defer(() => {
            this.scormApiService.setTrackingData(deliverableId, trackingData);

            document.getElementById('placeholder_contentIFrame').innerHTML = '';
            this.player.Run.ManifestByURL(manifest, true);

            return Observable.of(true).delay(5000);
        })
    }

    private handleError(error: any) {
        this.notificationService.error(error, 'Failed');
        this.ready();
    }

    private initScormButtons() {
        let PlayerConfiguration = this.player.PlayerConfiguration;

        PlayerConfiguration.Debug = false;
        PlayerConfiguration.StorageSupport = true;
        PlayerConfiguration.TreeMinusIcon = IMG_BUCKET_URL + 'minus.gif';
        PlayerConfiguration.TreePlusIcon = IMG_BUCKET_URL + 'plus.gif';
        PlayerConfiguration.TreeLeafIcon = IMG_BUCKET_URL + 'leaf.gif';
        PlayerConfiguration.TreeActiveIcon = IMG_BUCKET_URL + 'select.gif';

        PlayerConfiguration.BtnPreviousLabel = 'Previous';
        PlayerConfiguration.BtnContinueLabel = 'Continue';
        PlayerConfiguration.BtnExitLabel = 'Exit';
        PlayerConfiguration.BtnExitAllLabel = 'Exit All';
        PlayerConfiguration.BtnAbandonLabel = 'Abandon';
        PlayerConfiguration.BtnAbandonAllLabel = 'Abandon All';
        PlayerConfiguration.BtnSuspendAllLabel = 'Suspend All';
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/content/scorm/scorm.component.ts